import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';

const CommandHistoryPanel = ({ commandLogs, onExportCSV, onClear }) => {
  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="align-items-center mb-2">
          <Col>
            <h5 className="mb-0">📝 Histórico de Comandos</h5>
          </Col>
          <Col xs="auto">
            <Button
              size="sm"
              onClick={onExportCSV}
              disabled={commandLogs.length === 0}
              style={{
                backgroundColor: 'transparent',
                color: 'var(--success-color, #198754)',
                border: '1px solid var(--success-color, #198754)'
              }}
            >
              💾 Export CSV
            </Button>
            <Button
              size="sm"
              className="ms-2"
              onClick={onClear}
              disabled={commandLogs.length === 0}
              style={{
                backgroundColor: 'transparent',
                color: 'var(--text-muted, #6c757d)',
                border: '1px solid var(--text-muted, #6c757d)'
              }}
            >
              🗑️ Limpar
            </Button>
          </Col>
        </Row>
        <div style={{ maxHeight: 400, overflowY: 'auto', fontSize: '0.8rem' }}>
          {commandLogs.length === 0 ? (
            <p className="text-muted text-center py-4">Nenhum comando executado ainda</p>
          ) : (
            <table className="table table-sm table-hover">
              <thead style={{ position: 'sticky', top: 0, background: 'white' }}>
                <tr>
                  <th>Horário</th>
                  <th>Comando</th>
                  <th>Resultado</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {commandLogs.map((log, idx) => (
                  <tr key={idx}>
                    <td>{log.timestamp}</td>
                    <td><code>{log.command}</code></td>
                    <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {log.result}
                    </td>
                    <td>
                      <span className={`badge bg-${log.success ? 'success' : 'danger'}`}>
                        {log.success ? '✓' : '✗'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default CommandHistoryPanel;
